import { ref } from 'vue'
import { db } from './utils.mjs'

export const WALLET_LABEL_BY_KEY = {
  metamask: 'MetaMask',
  bitget: 'Bitget Wallet',
  ave: 'AVE Wallet',
  tokenPocket: 'TokenPocket',
  tronLink: 'TronLink',
  walletConnect: 'WalletConnect',
  trust: 'Trust Wallet',
  okx: 'OKX Wallet',
  coinbase: 'Coinbase Wallet',
  binance: 'Binance Wallet',
}

/** 响应式：当前会话钱包 key（图标/名称/UI 唯一来源） */
export const walletSessionKey = ref('')

export function labelForWalletKey(key) {
  const k = String(key || '').trim()
  return WALLET_LABEL_BY_KEY[k] || WALLET_LABEL_BY_KEY.metamask
}

export function applyWalletSession(key) {
  const k = String(key || '').trim()
  walletSessionKey.value = k
  if (k) {
    db.set('wallet_key', k)
    db.set('wallet_label', labelForWalletKey(k))
  }
}

export function clearWalletSession() {
  walletSessionKey.value = ''
  db.set('wallet_key', '')
  db.set('wallet_label', '')
}

export function hydrateWalletSessionFromDb() {
  const k = String(db.get('wallet_key', '') || '').trim()
  walletSessionKey.value = k
}
